<ul class="flex justify-between gap-2 md:gap-4">
  <li
    *ngFor="let step of steps; let i = index"
    class="flex w-28 md:w-16 flex-col items-center gap-1"
  >
    <div
      [ngClass]="{
            'border-apricot-1': activeStep >= i,
            'border-grey-7': activeStep < i,
            'bg-apricot-1': activeStep > i,
            'opacity-25': activeStep > i
          }"
      class="relative mx-auto flex h-5 w-5 items-center justify-center rounded-full border-2"
    >
      <app-ui-icon
        *ngIf="activeStep > i"
        color="var(--white)"
        name="check"
      ></app-ui-icon>
      <div
        *ngIf="i < 2"
        [ngClass]="activeStep > i ? 'bg-apricot-1' : 'bg-grey-7'"
        class="absolute left-full ml-1 h-0.5 w-24 md:w-14"
      ></div>
    </div>
    <span
      [ngClass]="activeStep === i ? 'text-grey-4' : 'text-grey-7'"
      class="whitespace-nowrap text-sm"
    >{{ step }}</span
    >
  </li>
</ul>
